export default __webpack_public_path__ + "static/CommunityShuttlePrograms-70b1f7b4ce4493c74eeef2320df904dc.jpg";